import api from 'api';

const unwrap = (res) => res.data.data;

export const fetchMortgageBrokerHub = async () =>
    unwrap(await api.get('/directory/mortgage-brokers'));

export const fetchMortgageBrokerTopic = async (slug) =>
    unwrap(
        await api.get(
            `/directory/mortgage-brokers/topic/${encodeURIComponent(slug)}`
        )
    );

export const fetchMortgageBrokerPage = async (slug) =>
    unwrap(
        await api.get(
            `/directory/mortgage-brokers/page/${encodeURIComponent(slug)}`
        )
    );

// Stories past the 210 on a topic or town page; topic: the /topic/[slug] route.
export const fetchStoryArchive = async (slug, page, { topic = false } = {}) =>
    unwrap(
        await api.get(
            `/directory/mortgage-brokers/${
                topic ? 'topic' : 'page'
            }/${encodeURIComponent(slug)}/stories/${page}`
        )
    );

// Town and topic back-links for a profile page; empty for anyone not listed.
export const fetchDirectoryProfile = async (slug, { timeout } = {}) =>
    unwrap(
        await api.get(
            `/directory/mortgage-brokers/profile/${encodeURIComponent(slug)}`,
            timeout ? { timeout } : undefined
        )
    );

// Admins only: whether the profile is listed, and the switch that takes it out.
export const fetchDirectoryStatus = async (profileId) =>
    unwrap(await api.get(`/directory/admin/profiles/${profileId}`));

export const setDirectoryExcluded = async (profileId, excluded) =>
    unwrap(
        await api.put(`/directory/admin/profiles/${profileId}/excluded`, {
            excluded,
        })
    );

export const fetchDirectoryExcluded = async () =>
    unwrap(await api.get('/directory/admin/excluded'));

// Admins only: the editor copy of every directory topic and town page.
export const fetchDirectoryPageCopy = async () =>
    unwrap(await api.get('/directory/admin/page-copy'));

export const saveDirectoryPageCopy = async (copy) =>
    unwrap(await api.put('/directory/admin/page-copy', copy));

// Admins only: the directory topic pages an alert's story is listed on.
export const fetchDirectoryTopics = async () =>
    unwrap(await api.get('/directory/admin/topics'));

export const fetchAlertDirectoryTopics = async (alertId) =>
    unwrap(await api.get(`/directory/admin/alerts/${alertId}/topics`));

export const saveAlertDirectoryTopics = async (
    alertId,
    expertiseIds,
    townSlugs
) =>
    unwrap(
        await api.put(`/directory/admin/alerts/${alertId}/topics`, {
            expertiseIds,
            townSlugs,
        })
    );
